import { render, staticRenderFns } from "./CommunityNotifications.vue?vue&type=template&id=bd26949c"
import script from "./CommunityNotifications.vue?vue&type=script&lang=js"
export * from "./CommunityNotifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/maq/Code/skyier/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bd26949c')) {
      api.createRecord('bd26949c', component.options)
    } else {
      api.reload('bd26949c', component.options)
    }
    module.hot.accept("./CommunityNotifications.vue?vue&type=template&id=bd26949c", function () {
      api.rerender('bd26949c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/app2/components/community/CommunityNotifications.vue"
export default component.exports